import { z } from "zod";
import { ufSchema } from "./calculation.js";
import { evidenceLocatorSchema } from "./evidence-locator.js";
const isoDate = z.string().date();
/**
 * Evidence of a published `cbsIbsRates` rule: the same identity fields fiscal rules already use
 * (`evidenceId`, content hash, source, optional locator).
 */
export const cbsIbsRateEvidenceSchema = z
    .object({
    evidenceId: z.string().uuid(),
    contentSha256: z.string().regex(/^[a-f0-9]{64}$/),
    source: z.string().min(1),
    sourceUrl: z.string().url().optional(),
    legalReference: z.string().optional(),
    locator: evidenceLocatorSchema.optional(),
    validFrom: isoDate.nullable(),
    validTo: isoDate.nullable(),
})
    .strict();
export const cbsIbsSphereSchema = z.enum(["CBS", "IBS_UF", "IBS_MUN"]);
export const cbsIbsRateKindSchema = z.enum([
    "TEST_2026",
    "TRANSITION_2027_2028",
    "REFERENCE",
    "ENTITY_LAW",
]);
/**
 * One published CBS/IBS rate. Optional `content.cbsIbsRates[]` on a ruleset; absent in every
 * ruleset today. Decimal `rate` is a fraction in [0, 1): "0.009" = 0.9 %.
 */
export const cbsIbsRateRuleSchema = z
    .object({
    id: z.string().uuid(),
    sphere: cbsIbsSphereSchema,
    /** "BR" (uniform, 2026–2028) or the UF of the destination (2029+ entity laws). */
    jurisdiction: z.union([z.literal("BR"), ufSchema]),
    /** Decimal fraction in [0, 1): "0.009" = 0.9 %. */
    rate: z.string().regex(/^0(\.\d{1,8})?$/),
    kind: cbsIbsRateKindSchema,
    mode: z.enum(["INFORMATIONAL", "DUE"]),
    validFrom: isoDate,
    validTo: isoDate.nullable(),
    legalReference: z.string().min(1).max(500),
    evidence: z.array(cbsIbsRateEvidenceSchema).min(1).max(20),
})
    .strict();
/** Optional `content.cbsIbsRates` on a published ruleset. */
export const cbsIbsRatesSchema = z.array(cbsIbsRateRuleSchema).max(200);
/** Proposal payload for a `cbsIbsRates` rule: the same shape that is published. */
export const cbsIbsRateProposalPayloadSchema = cbsIbsRateRuleSchema;
//# sourceMappingURL=cbs-ibs.js.map